<template>
    <Head title="FAQs"/>

    <div class="font-sans text-gray-900 antialiased">
        <div class="pt-4 bg-gray-100">
            <div class="min-h-screen flex flex-col items-center pt-6 sm:pt-0">
                <div>
                    <jet-authentication-card-logo/>
                </div>

                <div class="w-full sm:max-w-2xl mt-6 p-6 bg-white shadow-md overflow-hidden sm:rounded-lg prose">
                    <h2><strong>Frequently Askaed Qestions</strong></h2>
                    <div class="">
                        <div class="tab w-full overflow-hidden border-t">
                            <input class="absolute opacity-0" id="tab-single-one" type="radio" name="tabs2">
                            <label class="block p-5 leading-normal cursor-pointer" for="tab-single-one">
                                What is the Referex App?
                            </label>
                            <div
                                class="tab-content overflow-hidden border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                                <p class="p-5">
                                    We are an online business solution for individuals or agencies to keep track of how
                                    many visitors have come through each referral URL shared by influencers over the
                                    internet. With Referex App you can track each referrer's performance based on how
                                    much traffic he/she brings to a given campaign.
                                </p>
                            </div>
                        </div>
                        <div class="tab w-full overflow-hidden border-t">
                            <input class="absolute opacity-0" id="tab-single-two" type="radio" name="tabs2">
                            <label class="block p-5 leading-normal cursor-pointer" for="tab-single-two">
                                Who is a referrer / influencer?
                            </label>
                            <div
                                class="tab-content overflow-hidden border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                                <p class="p-5">
                                    A referrer or influencer is a person contracted to promote an online campaign on
                                    his/her social media accounts with an aim of driving traffic to the given
                                    campaign.
                                </p>
                            </div>
                        </div>
                        <div class="tab w-full overflow-hidden border-t">
                            <input class="absolute opacity-0" id="tab-single-three" type="radio" name="tabs2">
                            <label class="block p-5 leading-normal cursor-pointer" for="tab-single-three">
                                What is a campaign?
                            </label>
                            <div
                                class="tab-content overflow-hidden border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                                <p class="p-5">
                                    A campaign is a drive created to promote a website, service or online product page
                                    usually started by the marketing team of a business or a contracted marketing agency
                                    to create awareness or drive online traffic to it.
                                </p>
                            </div>
                        </div>
                        <div class="tab w-full overflow-hidden border-t">
                            <input class="absolute opacity-0" id="tab-single-four" type="radio" name="tabs2">
                            <label class="block p-5 leading-normal cursor-pointer" for="tab-single-four">
                                How does the 14 day free trial work?
                            </label>
                            <div
                                class="tab-content overflow-hidden border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                                <p class="p-5">
                                    Currently the free trial is only available on the <strong>Pro</strong> subscription
                                    plan for 14 days. You'll get to enjoy all the Pro Plan Features during this time at
                                    no charge even though your payment details will be collected but not charged until
                                    the trial period is complete.
                                </p>
                            </div>
                        </div>
                        <div class="tab w-full overflow-hidden border-t">
                            <input class="absolute opacity-0" id="tab-single-five" type="radio" name="tabs2">
                            <label class="block p-5 leading-normal cursor-pointer" for="tab-single-five">
                                Can I upgrade / downgrade plans any time?
                            </label>
                            <div
                                class="tab-content overflow-hidden border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                                <p class="p-5">
                                    Yes. If your current plan limits or exceeds your current needs you can upgrade,
                                    downgrade or cancel at any time. Click on "Subscription Plan" in your ReferexApp
                                    account, to change your plan.
                                </p>
                            </div>
                        </div>
                        <div class="tab w-full overflow-hidden border-t">
                            <input class="absolute opacity-0" id="tab-single-six" type="radio" name="tabs2">
                            <label class="block p-5 leading-normal cursor-pointer" for="tab-single-six">
                                Will my data be private and safe?
                            </label>
                            <div
                                class="tab-content overflow-hidden border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                                <p class="p-5">
                                    We take data security very seriously, our servers are hosted in a world class data
                                    center that is protected by 24-hour surveillance. We ensure that our application
                                    is always up to date with the latest securuty patches and all our plans include SSL
                                    encryption to keep your data safe.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pt-4 items-center text-center">
                    <h2>Have more questions?</h2>
                    <p>Contact our support team via <strong>support@referex.app</strong></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import {Head} from '@inertiajs/inertia-vue3';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'

export default defineComponent({
    props: ['terms'],

    components: {
        Head,
        JetAuthenticationCardLogo,
    },
    mounted() {
        let myRadios = document.getElementsByName('tabs2');
        let setCheck;
        for (let x = 0; x < myRadios.length; x++) {
            myRadios[x].onclick = function () {
                if (setCheck !== this) {
                    setCheck = this;
                } else {
                    this.checked = false;
                    setCheck = null;
                }
            };
        }
    }
})
</script>

<style scoped>
/* Tab content - closed */
.tab-content {
    max-height: 0;
    -webkit-transition: max-height .35s;
    -o-transition: max-height .35s;
    transition: max-height .35s;
}

/* :checked - resize to full height */
.tab input:checked ~ .tab-content {
    max-height: 100vh;
}

/* Label formatting when open */
.tab input:checked + label {
    /*@apply text-xl p-5 border-l-2 border-indigo-500 bg-gray-100 text-indigo*/
    font-size: 1.25rem; /*.text-xl*/
    padding: 1.25rem; /*.p-5*/
    border-left-width: 2px; /*.border-l-2*/
    border-color: #3E13A5; /*.border-indigo*/
    background-color: #f8fafc; /*.bg-gray-100 */
    color: #3E13A5; /*.text-indigo*/
}

/* Icon */
.tab label::after {
    float: right;
    right: 0;
    top: 0;
    display: block;
    width: 1.5em;
    height: 1.5em;
    line-height: 1.5;
    font-size: 1.25rem;
    text-align: center;
    -webkit-transition: all .35s;
    -o-transition: all .35s;
    transition: all .35s;
}

/* Icon formatting - closed */
.tab input[type=checkbox] + label::after {
    content: "+";
    font-weight: bold; /*.font-bold*/
    border-width: 1px; /*.border*/
    border-radius: 9999px; /*.rounded-full */
    border-color: #b8c2cc; /*.border-grey*/
}

.tab input[type=radio] + label::after {
    content: "\25BE";
    font-weight: bold; /*.font-bold*/
    border-width: 1px; /*.border*/
    border-radius: 9999px; /*.rounded-full */
    border-color: #b8c2cc; /*.border-grey*/
}

/* Icon formatting - open */
.tab input[type=checkbox]:checked + label::after {
    transform: rotate(315deg);
    background-color: #3E13A5; /*.bg-indigo*/
    color: #f8fafc; /*.text-grey-lightest*/
}

.tab input[type=radio]:checked + label::after {
    transform: rotateX(180deg);
    background-color: #3E13A5; /*.bg-indigo*/
    color: #f8fafc; /*.text-grey-lightest*/
}
</style>
